import u from "zustand/vanilla";
import { NetworkStatus as d } from "../../networkStatus.mjs";
import { deduplicateItems as i, sortItems as c } from "./utils.mjs";
const f = (
  // @ts-expect-error workaround for issue above
  typeof u == "function" ? u : u.default
);
function m(e) {
  const t = i(e);
  return c(t);
}
const p = {
  shouldSetPage: !0,
  shouldAppend: !1
}, l = {
  items: [],
  metadata: {
    total_count: 0,
    unread_count: 0,
    unseen_count: 0
  },
  pageInfo: {
    before: null,
    after: null,
    page_size: 50
  }
};
function h() {
  return f((e) => ({
    // Keeps track of all of the items loaded
    ...l,
    // The network status indicates what's happening with the request
    networkStatus: d.ready,
    loading: !1,
    setNetworkStatus: (t) => e(() => ({
      networkStatus: t,
      loading: t === d.loading
    })),
    setResult: ({ entries: t, meta: r, page_info: s }, a = p) => e((o) => ({
      items: a.shouldAppend ? m(o.items.concat(t)) : t,
      metadata: r,
      pageInfo: a.shouldSetPage ? s : o.pageInfo,
      loading: !1,
      networkStatus: d.ready
    })),
    setMetadata: (t) => e(() => ({ metadata: t })),
    resetStore: (t = l.metadata) => e(() => ({ ...l, metadata: t })),
    setItemAttrs: (t, r) => {
      const s = t.reduce(
        (a, o) => ({ ...a, [o]: r }),
        {}
      );
      return e((a) => ({ items: a.items.map((n) => s[n.id] ? { ...n, ...s[n.id] } : n) }));
    }
  }));
}
export {
  h as default
};
//# sourceMappingURL=store.mjs.map
